import { render, staticRenderFns } from "./currency_detail.vue?vue&type=template&id=57cb0934&scoped=true"
import script from "./currency_detail.vue?vue&type=script&lang=js"
export * from "./currency_detail.vue?vue&type=script&lang=js"
import style0 from "./currency_detail.vue?vue&type=style&index=0&id=57cb0934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb0934",
  null
  
)

export default component.exports